// Room socket message types
import { RoomClientMessageType, RoomServerMessageType, } from './enums';
/**
 * Error types
 */
export var WebSocketErrorType;
(function (WebSocketErrorType) {
    WebSocketErrorType["INVALID_MESSAGE"] = "invalid_message";
    WebSocketErrorType["UNAUTHORIZED"] = "unauthorized";
    WebSocketErrorType["RATE_LIMITED"] = "rate_limited";
    WebSocketErrorType["INTERNAL_ERROR"] = "internal_error";
    WebSocketErrorType["BAD_REQUEST"] = "bad_request";
})(WebSocketErrorType || (WebSocketErrorType = {}));
/**
 * Type guards for message types
 */
export function isRoomClientMessage(message) {
    return (typeof message === 'object' &&
        message !== null &&
        'type' in message &&
        'payload' in message &&
        Object.values(RoomClientMessageType).includes(message.type));
}
export function isRoomServerMessage(message) {
    return (typeof message === 'object' &&
        message !== null &&
        'type' in message &&
        'payload' in message &&
        Object.values(RoomServerMessageType).includes(message.type));
}
//# sourceMappingURL=roomMessages.js.map